<div class="language-switcher">
  <div class="language" [matMenuTriggerFor]="languageMenu">
    <div class="icon" [style.background-image]="LanguageEnum.icon(language())"></div>
    <div class="name">{{ LanguageEnum.name(language()) | translate }}</div>
  </div>
  <mat-menu #languageMenu="matMenu" class="language-menu">
    @for (item of LanguageEnum.languages; track item) {
      <div class="item" [class.active]="item === language()" (click)="language.set(item)">
        <div class="icon" [style.background-image]="LanguageEnum.icon(item)"></div>
        <div class="name">{{ LanguageEnum.name(item) | translate }}</div>
      </div>
    }
  </mat-menu>
</div>
